var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticStyle:{"width":"100%","height":"calc(80vh)"},attrs:{"src":"https://share-docs.clickup.com/3807076/d/h/3m5v4-47845/a766308d95dde41","frameborder":"0","scrolling":"auto","onload":"scroll(10,0);"}})
}
var staticRenderFns = []

export { render, staticRenderFns }